// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';

import { PaymentInstrument, InstrumentId } from './PaymentInstrument';
import { Amount } from './Amount';

import type {
    PaymentInstrumentModelType,
    InstrumentIdModelType
} from './PaymentInstrument';
import type { AmountModelType } from './Amount';

export type PaymentModelType = {
    instrument: PaymentInstrumentModelType,
    paymentId: PaymentIdModelType,
    desiredAmount: AmountModelType,
    actualAmount: AmountModelType,
    amountEditable: boolean,
    createdOn: string,
    updatedOn: string,
    additionalInfo: Object
};

export type PaymentIdModelType = {
    instrumentId: InstrumentIdModelType,
    paymentId: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class Payment extends ImmutableModel {
    static fromJS(json: PaymentModelType): Payment {
        const state: Object = Object.assign({}, json);
        state.instrument = PaymentInstrument.fromJS(state.instrument);
        state.paymentId = PaymentId.fromJS(state.paymentId);
        state.desiredAmount = Amount.fromJS(state.desiredAmount);
        state.actualAmount = Amount.fromJS(state.actualAmount);
        return new this(Immutable.Map(state));
    }

    toJS(): PaymentModelType {
        return {
            instrument: this.instrument.toJS(),
            paymentId: this.paymentId.toJS(),
            desiredAmount: this.desiredAmount.toJS(),
            actualAmount: this.actualAmount.toJS(),
            amountEditable: this.amountEditable,
            createdOn: this.createdOn,
            updatedOn: this.updatedOn,
            additionalInfo: this.additionalInfo
        };
    }

    get instrument(): PaymentInstrument {
        return this._state.get('instrument');
    }

    setInstrument(instrument: PaymentInstrument): this {
        return this.clone(this._state.set('instrument', instrument));
    }

    get paymentId(): PaymentId {
        return this._state.get('paymentId');
    }

    setPaymentId(paymentId: PaymentId): this {
        return this.clone(this._state.set('paymentId', paymentId));
    }

    get desiredAmount(): Amount {
        return this._state.get('desiredAmount');
    }

    setDesiredAmount(desiredAmount: Amount): this {
        return this.clone(this._state.set('desiredAmount', desiredAmount));
    }

    get actualAmount(): Amount {
        return this._state.get('actualAmount');
    }

    setActualAmount(actualAmount: Amount): this {
        return this.clone(this._state.set('actualAmount', actualAmount));
    }

    get amountEditable(): boolean {
        return this._state.get('amountEditable');
    }

    setAmountEditable(amountEditable: boolean): this {
        return this.clone(this._state.set('amountEditable', amountEditable));
    }

    get createdOn(): string {
        return this._state.get('createdOn');
    }

    setCreatedOn(createdOn: string): this {
        return this.clone(this._state.set('createdOn', createdOn));
    }

    get updatedOn(): string {
        return this._state.get('updatedOn');
    }

    setUpdatedOn(updatedOn: string): this {
        return this.clone(this._state.set('updatedOn', updatedOn));
    }

    get additionalInfo(): Object {
        return this._state.get('additionalInfo');
    }

    setAdditionalInfo(additionalInfo: Object): this {
        return this.clone(this._state.set('additionalInfo', additionalInfo));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PaymentId extends ImmutableModel {
    static fromJS(json: PaymentIdModelType): PaymentId {
        const state: Object = Object.assign({}, json);
        state.instrumentId = InstrumentId.fromJS(state.instrumentId);
        return new this(Immutable.Map(state));
    }

    toJS(): PaymentIdModelType {
        return {
            instrumentId: this.instrumentId.toJS(),
            paymentId: this.paymentId
        };
    }

    get instrumentId(): InstrumentId {
        return this._state.get('instrumentId');
    }

    setInstrumentId(instrumentId: InstrumentId): this {
        return this.clone(this._state.set('instrumentId', instrumentId));
    }

    get paymentId(): string {
        return this._state.get('paymentId');
    }

    setPaymentId(paymentId: string): this {
        return this.clone(this._state.set('paymentId', paymentId));
    }
}
